import React, { useEffect, useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import VisibilityIcon from '@material-ui/icons/Visibility';
import TableChart from '@material-ui/icons/TableChart';

import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Pagination from '@material-ui/lab/Pagination';
import FormatLineSpacingIcon from '@material-ui/icons/FormatLineSpacing';
import CustomInput from "components/CustomInput/CustomInput.js";
import Search from "@material-ui/icons/Search";
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

import Button from "components/CustomButtons/Button.js";
import Table from "components/Table/Table.js";
import CardIcon from "components/Card/CardIcon.js";
import Icon from "@material-ui/core/Icon";
import CardFooter from "components/Card/CardFooter.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import api from "assets/services/api.js";
import styles2 from "assets/jss/material-dashboard-react/components/tasksStyle.js";
import styles3 from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import { Form, Col } from "react-bootstrap";
import ModalUpdateClients from "components/ModalUpdateClients/ModalUpdateClients";
import ModalAddClients from "components/ModalAddClients/ModalAddClients";
import ModalDeleteClients from "components/ModalDeleteClients/ModalDeleteClients";
import ModalViewSellsman from "components/ModalViewSellsman/ModalViewSellsman";
import ModalUpdateSellsmanOfClient from "components/ModalUpdateSellsmanOfClient/ModalUpdateSellsmanOfClient";
import ModalUpdateClientZone from "components/ModalUpdateClientZone/ModalUpdateClientZone";
import ModalViewTabulation from "components/ModalViewTabulation/ModalViewTabulation";
import ModalAllTabulation from "components/ModaAllTabulation/ModalAllTabulation";
import ModalEnableClient from "components/ModalEnableClient/ModalEnableClient";
import ModalEnableClientPerm from "components/ModalEnableClientPerm/ModalEnableClientPerm";
import ModalViewContacts from "components/ModalViewContacts/ModalViewContacts";
import ModalViewSpc from "components/ModalViewSpc/ModalViewSpc";

import { FaDoorOpen } from "react-icons/fa";

import "react-datepicker/dist/react-datepicker.css";
import useAuth from "hooks/useAuth";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    colorCard: {
        color: "#999"
    },
    floatRight: {
        float: "right"
    },
    maxwidht: {
        maxWidth: "107%"
    },
    toogleclass: {
        marginTop: "14px",
        marginBottom: "14px",
        width: "65%",
    },
    backGreen: {
        backgroundColor: "#4caf50"
    },
    backRed: {
        backgroundColor: "rgb(244 67 54 / 1)"
    },
    zindex: {
        zIndex: "0 !important"
    },
    acctAll: {
        float: "right",
        marginTop: "-29px"
    },
    marginDate: {
        marginTop: "12px",
        marginBottom: "12px"
    },
    colorRed: {
        color: 'red'
    },
    colorOrange: {
        color: '#ff9500'
    },
    colorBlack: {
        color: '#0000'
    }
};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);
const useStyles3 = makeStyles(styles3);


export default function Clients() {
    const classes = useStyles();
    const { storageId } = useAuth();

    const classes2 = useStyles2();
    const classes3 = useStyles3();

    const [clients, setClients] = useState([]);

    const [search, setSearch] = useState("")
    const [totalPages, setTotalPages] = useState();
    const [page, setPage] = useState(1);
    const [sellsmans, setSellsmans] = useState([{ name: 'SELECIONE', lastname: "VENDEDOR", id: false }]);
    const [sellsmanId, setSellsmanId] = useState(false);

    const [modal, setModal] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [modalShowUpdate, setModalShowUpdate] = useState(false);
    const [modalShowDelete, setModalShowDelete] = useState(false);
    const [modalShowViewSells, setModalShowViewSells] = useState(false);
    const [modalUpdateSellsman, setModalUpdateSellsman] = useState(false);
    const [modalShowTabulation, setModalShowTabulation] = useState(false);
    const [modalAllTabulation, setModalAllTabulation] = useState(false);
    const [modalShowEnable, setModalShowEnable] = useState(false);
    const [modalShowEnablePerm, setModalShowEnablePerm] = useState(false);
    const [modalContacts, setModalContacts] = useState(false);
    const [modalSpc, setModalSpc] = useState(false);
    const [modalShowZone, setModalShowZone] = useState(false);
    const [index, setIndex] = useState({ id: 1 });
    useEffect(() => {
        getAllClients();
        loadSellsman();
    }, []);
    useEffect(() => {
        getAllClients();
    }, [totalPages, page, search, sellsmanId]);
    const loadModal = async () => {
        setModal(true);
    };
    function callModalAdd() {
        if (!modalShowUpdate) {
            loadModal();
        }
        setModalShow(true);
    };
    function callModal(index) {
        if (!modalShowUpdate) {
            loadModal();
        }
        setIndex(index);
        setModalShowUpdate(true);
    };
    function callViewSellsman(index) {
        if (!modalShowViewSells) {
            loadModal();
        }
        setIndex(index);
        setModalShowViewSells(true);
    };
    function callUpdateSellsman(index) {
        if (!modalUpdateSellsman) {
            loadModal();
        }
        setIndex(index);
        setModalUpdateSellsman(true);
    };
    function callModalDelete(index) {
        if (!modalShowDelete) {
            loadModal();
        }
        setIndex(index);
        setModalShowDelete(true);
    };
    function callModalTabulation(index) {
        if (!modalShowTabulation) {
            loadModal();
        }
        setIndex(index);
        setModalShowTabulation(true);
    };
    function callModalEnable(index) {
        if (!modalShowEnable) {
            loadModal();
        }
        setIndex(index);
        setModalShowEnable(true);
    };
    function callModalEnablePermanet(index) {
        if (!modalShowEnable) {
            loadModal();
        }
        setIndex(index);
        setModalShowEnablePerm(true);
    };
    function callModalContacts(index) {
        if (!modalContacts) {
            loadModal();
        }
        setIndex(index);
        setModalContacts(true);
    };;
    function callModalSpc(index) {
        if (!modalSpc) {
            loadModal();
        }
        setIndex(index);
        setModalSpc(true);
    };
    function callModalZone(index) {
        if (!modalShowZone) {
            loadModal();
        }
        setIndex(index);
        setModalShowZone(true);
    }
    const handleChange = (event, value) => {
        setPage(value);
    };
    async function getAllClients() {
        try {
            const response = await api.get(`/client/admin/${storageId}?page=${page}&search=${search}&sellsman=${sellsmanId}`);
            setClients(response.data.clients);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            alert('erro: ' + error)
        }
    };
    async function loadSellsman() {
        const response = await api.get(`sellsman/admin/type/all/${storageId}`);
        if (response.status === 200) {
            setSellsmans([...sellsmans, ...response.data]);
        };
    };
    function getClientsForTable() {
        let teste = [];
        for (let i = 0; i < clients.length; i++) {
            let enterprise = '';
            if (clients[i].name_enterprise) {
                const enterpriseSlice = clients[i].name_enterprise.split(' ');
                enterprise = `${enterpriseSlice[0]} ${enterpriseSlice[1]}`
            }
            teste[i] = [];
            teste[i].push(clients[i].fantasy_name);
            if (clients[i].disabled) {
                teste[i].push(<div className={classes.colorRed}>{clients[i].social_reason}</div>);
            } else if (!clients[i].enable) {
                teste[i].push(<div className={classes.colorOrange}>{clients[i].social_reason}</div>);
            } else {
                teste[i].push(<div>{clients[i].social_reason}</div>);
            };
            teste[i].push(clients[i].cnpj);
            teste[i].push(`${clients[i].address}, ${clients[i].number}, ${clients[i].neighborhood}, ${clients[i].city} - ${clients[i].cep}`);
            teste[i].push(enterprise);
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip id="tooltip-top" title="Contatos" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModalZone(clients[i])}>
                            <VisibilityIcon className={classes2.tableActionButtonIcon + " " + classes2.view} />
                        </IconButton>
                    </Tooltip>
                </div>
            );
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip id="tooltip-top" title="Contatos" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModalContacts(clients[i])}>
                            <ContactPhoneIcon className={classes2.tableActionButtonIcon2 + " " + classes2.table} />
                        </IconButton>
                    </Tooltip>
                </div>
            );
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip id="tooltip-top" title="SPC" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModalSpc(clients[i])}>
                            <VisibilityIcon className={classes2.tableActionButtonIcon + " " + classes2.view} />
                        </IconButton>
                    </Tooltip>
                    <CardIcon>
                        <Icon title={clients[i].aproved_admin ? "Validado" : "Não validado"}>{clients[i].aproved_admin ? "done" : "clear"}</Icon>
                    </CardIcon>
                </div>
            );
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip id="tooltip-top" title="Visualizar vendedor" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callViewSellsman(clients[i])}>
                            <VisibilityIcon className={classes2.tableActionButtonIcon + " " + classes2.view} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip id="tooltip-top" title="Tabelas de preço" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModalTabulation(clients[i])}>
                            <FormatLineSpacingIcon className={classes2.tableActionButtonIcon + " " + classes2.table} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip id="tooltip-top" title="Editar" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callUpdateSellsman(clients[i])}>
                            <Edit className={classes2.tableActionButtonIcon + " " + classes2.edit} />
                        </IconButton>
                    </Tooltip>
                </div>
            );
            teste[i].push(
                <div className={classes2.tableActions}>
                    <Tooltip id="tooltip-top" title="Editar" placement="top" classes={{ tooltip: classes2.tooltip }} >
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModal(clients[i])} >
                            <Edit className={classes2.tableActionButtonIcon + " " + classes2.edit} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip id="tooltip-top" title="Habilitar/desabilitar permanentimente" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModalEnablePermanet(clients[i])}>
                            <FaDoorOpen className={classes2.tableActionButtonIcon + " " + classes2.edit7} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip id="tooltip-top" title="Habilitar/desabilitar" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Edit" className={classes2.tableActionButton} onClick={() => callModalEnable(clients[i])}>
                            <FaDoorOpen className={classes2.tableActionButtonIcon + " " + classes2.edit6} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip id="tooltip-top-start" title="Deletar" placement="top" classes={{ tooltip: classes2.tooltip }}>
                        <IconButton aria-label="Close" className={classes2.tableActionButton} onClick={() => callModalDelete(clients[i])}>
                            <Close className={classes2.tableActionButtonIcon + " " + classes2.close} />
                        </IconButton>
                    </Tooltip>
                </div>
            );
        };
        return teste;
    };
    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={8}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="success">
                                <Icon>content_copy</Icon>
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <h6 className={classes.colorCard}>Clique abaixo para adicionar um cliente</h6>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <Button color="success" className={classes.margintp + classes.maxwidht} onClick={() => callModalAdd()}>
                            Adicionar cliente
                        </Button>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
                <Card>
                    <div className={classes.zindex}>
                        <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                            <CardIcon color="success">
                                <PersonSearchIcon />
                            </CardIcon>
                        </CardHeader>
                    </div>
                    <CardBody className="d-flex justify-content-center">
                        <h6 className={classes.colorCard}>Clique abaixo para filtrar por vendedor</h6>
                    </CardBody>
                    <CardFooter className="d-flex justify-content-center" stats>
                        <div className="d-flex justify-content-center">
                            <Form.Row className={classes.widthSelect} >
                                <Form.Group as={Col} controlId="formGridSellsman">
                                    <Form.Control onChange={event => setSellsmanId(event.target.value)} value={sellsmanId} as="select" defaultValue="Choose...">
                                        {sellsmans.map(sellsman => (
                                            <option key={String(sellsman.id)} value={sellsman.id}>{sellsman.name + " " + sellsman.lastname}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </Form.Row>
                        </div>
                    </CardFooter>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <div className={classes3.searchWrapper}>
                    <CustomInput
                        formControlProps={{
                            className: classes3.margin + " " + classes3.search
                        }}
                        inputProps={{
                            placeholder: "Busca por cnpj, razão social ou nome fantasia",
                            inputProps: {
                                "aria-label": "Search",
                                type: "text",
                                value: search,
                                onChange: event => setSearch(event.target.value)
                            }
                        }}
                    />
                    <Button color="white" aria-label="edit" justIcon round>
                        <Search />
                    </Button>
                </div>
            </GridItem>
            <Card>
                <CardHeader className={classes.zindex} color={"primary"}>
                    <h4 className={classes.cardTitleWhite}>Clientes destinados a operação</h4>
                    <div className={classes.acctAll}>
                        <Tooltip
                            id="tooltip-top"
                            title={"Relatório com todas as tabelas de todos os clientes"}
                            placement="top"
                            classes={{ tooltip: classes2.tooltip }}
                        >
                            <IconButton
                                aria-label="Done"
                                className={classes2.tableActionButton}
                                onClick={() => setModalAllTabulation(true)}
                            >
                                <TableChart
                                    className={
                                        classes2.tableActionButtonIcon + " " + classes2.edit2
                                    }
                                />
                            </IconButton>
                        </Tooltip>
                    </div>

                </CardHeader>
                <CardBody>
                    <Table
                        index={index}
                        tableHeaderColor="primary"
                        tableHead={["Nome fantasia", "Razão Social", "CPF/CNPJ", "Endereço", "Empresa", "Zona", "Contato", "Validação", "Vendedor", "Ações"]}
                        tableData={getClientsForTable()}
                    />
                </CardBody>
            </Card>
            {modalShowTabulation && modal && (
                <ModalViewTabulation key={`Tabulation_${index.id}`} props={index} show={modalShowTabulation} onHide={() => setModalShowTabulation(false)} getAllClients={getAllClients} />
            )}
            {modalShowViewSells && modal && (
                <ModalViewSellsman key={`ViewSells_${index.id}`} props={index} show={modalShowViewSells} onHide={() => setModalShowViewSells(false)} />
            )}
            {modalUpdateSellsman && modal && (
                <ModalUpdateSellsmanOfClient key={`UpdSells_${index.id}`} props={index} show={modalUpdateSellsman} onHide={() => setModalUpdateSellsman(false)} getAllClients={getAllClients} />
            )}
            {modalShow && modal && (
                <ModalAddClients key={`Cli_${index.id}`} props={index} show={modalShow} onHide={() => setModalShow(false)} getAllClients={getAllClients} />
            )}
            {modalShowUpdate && modal && (
                <ModalUpdateClients key={`Upd_${index.id}`} props={index} show={modalShowUpdate} onHide={() => setModalShowUpdate(false)} getAllClients={getAllClients} />
            )}
            {modalShowDelete && modal && (
                <ModalDeleteClients key={`del_${index.id}`} props={index} show={modalShowDelete} onHide={() => setModalShowDelete(false)} getAllClients={getAllClients} />
            )}
            {modalAllTabulation && modal && (
                <ModalAllTabulation key={`all_${index.id}`} show={modalAllTabulation} onHide={() => setModalAllTabulation(false)} />
            )}
            {modalShowEnable && modal && (
                <ModalEnableClient key={`Ena_${index.id}`} props={index} show={modalShowEnable} onHide={() => setModalShowEnable(false)} getAllClients={getAllClients} />
            )}
            {modalShowEnablePerm && modal && (
                <ModalEnableClientPerm key={`Ena_perm${index.id}`} props={index} show={modalShowEnablePerm} onHide={() => setModalShowEnablePerm(false)} getAllClients={getAllClients} />
            )}
            {modalContacts && modal && (
                <ModalViewContacts key={`Con_${index.id}`} props={index} show={modalContacts} onHide={() => setModalContacts(false)} getAllClients={getAllClients} />
            )}
            {modalSpc && modal && (
                <ModalViewSpc key={`Spc_${index.id}`} props={index} show={modalSpc} onHide={() => setModalSpc(false)} getAllClients={getAllClients} />
            )}
            {modalShowZone && modal && (
                <ModalUpdateClientZone key={`Zone_${index.id}`} props={index} show={modalShowZone} onHide={() => setModalShowZone(false)} getAllClients={getAllClients} />
            )}
            <Pagination count={totalPages} page={page} onChange={handleChange} />
        </GridContainer>
    );

}
